import { useEffect } from 'react';

// Redux & Action
import { useSelector, useDispatch } from 'react-redux';
import { setWithdrawRankData } from '@core/redux/actions/withdraw/index';

// Component
import Content from "./Content";

const Rank = ({ dataCms }) => {
    const dispatch = useDispatch();
    const withdrawRank = useSelector(state => state.reduxWithdraw.rank);

    const renderContent = () => {
        if(withdrawRank !== null) {
            return (
                <Content dataCms={dataCms} withdrawRank={withdrawRank} />
            );
        }
    };

    useEffect(() => {
        dispatch(setWithdrawRankData());
    }, []);

    return renderContent();
}

export default Rank;